module.exports = __webpack_public_path__ + "img/icon_classify04.51847f52.png";